"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _currency = require("../../../currency");
var _newComponents = require("../../../new-components");
var WeekRowButton = function WeekRowButton(_ref) {
  var _ref$weekRow = _ref.weekRow,
    comingSoon = _ref$weekRow.comingSoon,
    fromPrice = _ref$weekRow.fromPrice,
    selectWeek = _ref$weekRow.selectWeek,
    soldOut = _ref$weekRow.soldOut,
    openWaitingListModal = _ref$weekRow.openWaitingListModal,
    crossSell = _ref$weekRow.crossSell,
    ultraCrossSell = _ref$weekRow.ultraCrossSell,
    week = _ref$weekRow.week;
  if (comingSoon) {
    return /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
      buttonType: _newComponents.BUTTON_TYPES.GHOST,
      onClick: openWaitingListModal
    }, "Sign up");
  }
  if (!soldOut) {
    return /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
      buttonType: _newComponents.BUTTON_TYPES.PRIMARY,
      onClick: selectWeek
    }, fromPrice.count && 'From ', /*#__PURE__*/_react["default"].createElement(_currency.FormatCurrency, {
      amount: fromPrice.price / 100,
      baseCurrency: week.currency
    }), "\xA0/\xA0", /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
      name: "person",
      fill: _newComponents.COLORS.PRIMARY
    }));
  }
  if (ultraCrossSell) {
    return /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
      buttonType: _newComponents.BUTTON_TYPES.SECONDARY,
      onClick: function onClick() {
        return ultraCrossSell.action();
      }
    }, "Upgrade now");
  }
  if (crossSell) {
    return /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
      buttonType: _newComponents.BUTTON_TYPES.SECONDARY,
      onClick: function onClick() {
        return crossSell.action();
      }
    }, "Book now for ", ' ', /*#__PURE__*/_react["default"].createElement(_currency.FormatCurrency, {
      amount: crossSell.price,
      baseCurrency: week.currency
    }), "/", /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
      name: "person",
      fill: _newComponents.COLORS.PRIMARY
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
    buttonType: _newComponents.BUTTON_TYPES.SECONDARY,
    onClick: openWaitingListModal
  }, "Join waiting list");
};
WeekRowButton.propTypes = {
  weekRow: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = WeekRowButton;